module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("security")]), _vm._v(" Permisos para " + _vm._s(_vm.modulo.label) + "\n    "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 2)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-alert', {
    staticClass: "alert-permiso",
    attrs: {
      "color": "info",
      "icon": "info",
      "value": "true"
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_vm._v("Habilite/deshabilite los permisos del módulo para cada rol, donde:")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Con permiso",
      "value": true,
      "text-color": "white",
      "color": "primary"
    },
    on: {
      "change": function($event) {
        _vm.activo = true
      }
    },
    model: {
      value: (_vm.activo),
      callback: function($$v) {
        _vm.activo = $$v
      },
      expression: "activo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Sin permiso",
      "text-color": "white",
      "color": "primary"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Rol")]), _vm._v(" "), _c('th', {
    staticClass: "width-permiso"
  }, [_vm._v("Ver")]), _vm._v(" "), _c('th', {
    staticClass: "width-permiso"
  }, [_vm._v("Crear")]), _vm._v(" "), _c('th', {
    staticClass: "width-permiso"
  }, [_vm._v("Actualizar")]), _vm._v(" "), _c('th', {
    staticClass: "width-permiso"
  }, [_vm._v("Eliminar")]), _vm._v(" "), _c('th', {
    staticClass: "width-permiso"
  }, [_vm._v("CSV")]), _vm._v(" "), _c('th', {
    staticClass: "width-permiso"
  }, [_vm._v("Firmar")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permisos), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "title-permiso"
    }, [_c('strong', [_vm._v(_vm._s(item.rol_nombre))]), _c('br'), _vm._v(" "), _c('sub', [_c('em', [_vm._v(_vm._s(item.rol_descripcion))])])]), _vm._v(" "), _c('td', [_c('v-switch', {
      attrs: {
        "color": "primary"
      },
      on: {
        "change": function($event) {
          return _vm.setPermiso(item)
        }
      },
      model: {
        value: (item.read),
        callback: function($$v) {
          _vm.$set(item, "read", $$v)
        },
        expression: "item.read"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-switch', {
      attrs: {
        "color": "primary"
      },
      on: {
        "change": function($event) {
          return _vm.setPermiso(item)
        }
      },
      model: {
        value: (item.create),
        callback: function($$v) {
          _vm.$set(item, "create", $$v)
        },
        expression: "item.create"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-switch', {
      attrs: {
        "color": "primary"
      },
      on: {
        "change": function($event) {
          return _vm.setPermiso(item)
        }
      },
      model: {
        value: (item.update),
        callback: function($$v) {
          _vm.$set(item, "update", $$v)
        },
        expression: "item.update"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-switch', {
      attrs: {
        "color": "primary"
      },
      on: {
        "change": function($event) {
          return _vm.setPermiso(item)
        }
      },
      model: {
        value: (item.delete),
        callback: function($$v) {
          _vm.$set(item, "delete", $$v)
        },
        expression: "item.delete"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-switch', {
      attrs: {
        "color": "primary"
      },
      on: {
        "change": function($event) {
          return _vm.setPermiso(item)
        }
      },
      model: {
        value: (item.csv),
        callback: function($$v) {
          _vm.$set(item, "csv", $$v)
        },
        expression: "item.csv"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-switch', {
      attrs: {
        "color": "primary"
      },
      on: {
        "change": function($event) {
          return _vm.setPermiso(item)
        }
      },
      model: {
        value: (item.firma),
        callback: function($$v) {
          _vm.$set(item, "firma", $$v)
        },
        expression: "item.firma"
      }
    })], 1)])
  }), 0)])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 2);
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.close')) + "\n    ")], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f4fc737","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/modulo/Permisos.vue
// module id = 532
// module chunks = 2